import { FALLBACK_AUTHOR, User } from '../../User';
import { RComment } from '../remote/comment';
import { Comment } from '../domain/comment';
import { parseISO } from 'date-fns';
import { userToAuthor } from '../../../api/helpers';

export const mapComments = (comments: RComment[], authors: User[]) => {

    const mapComment = (comment: RComment): Comment => {
        const mainAuthor = authors.find(({ id }) => id === comment.author.id);

        const {
            documentId,
            content,
            blocked,
            blockedThread,
            createdAt,
            updatedAt,
            gotThread,
            threadFirstItemId
        } = comment;

        return {
            id: documentId,
            content,
            blocked,
            blockedThread,
            createdAt: parseISO(createdAt),
            updatedAt: parseISO(updatedAt),
            gotThread,
            threadFirstItemId,
            author: mainAuthor ? userToAuthor(mainAuthor) : FALLBACK_AUTHOR,
            // Map children recursively
            children: comment.children.map(mapComment)
        };
    };

    return comments.map(mapComment);
};
